export default __webpack_public_path__ + "static/media/bg-ring-0.77909721.png";